import classnames from 'classnames';
import PropTypes from 'prop-types';
import {PresentationMap, DeckGlMap} from '@gisatcz/ptr-maps';
import {connects} from '@gisatcz/ptr-state';

import Division from './divisions/Division';
import Interferometry from './divisions/Interferometry';
import Zones from './divisions/Zones';

import './style.scss';

const Map = connects.Map(PresentationMap);

const ControlPanel = ({
	activeDivision,
	chartExpanded,
	minimised,
	interferometryConfiguration,
	zonesConfiguration,
	onActiveDivisionChange,
}) => {
	const classes = classnames('insar-ControlPanel', {
		'is-minimised': minimised,
		'is-chartExpanded': chartExpanded,
	});

	return (
		<div className={classes}>
			<div className="insar-ControlPanel-top-padding" />
			<div className="insar-ControlPanel-content">
				<Division
					active={activeDivision === 'zones'}
					onButtonClick={() => onActiveDivisionChange('zones')}
					ActiveButtonContent={
						<Map
							stateMapKey={zonesConfiguration.smallMapKey}
							mapComponent={DeckGlMap}
						/>
					}
					Title={<h4>Exposure to land subsidence</h4>}
				>
					<Zones />
				</Division>
				<Division
					active={activeDivision === 'interferometry'}
					onButtonClick={() => onActiveDivisionChange('interferometry')}
					ActiveButtonContent={
						<Map
							stateMapKey={interferometryConfiguration.smallMapKey}
							mapComponent={DeckGlMap}
						/>
					}
					Title={
						<h4>
							Ground deformation<span> - InSAR measurement points</span>
						</h4>
					}
				>
					<Interferometry />
				</Division>
			</div>
		</div>
	);
};

ControlPanel.propTypes = {
	activeDivision: PropTypes.string,
	chartExpanded: PropTypes.bool,
	minimised: PropTypes.bool,
	interferometryConfiguration: PropTypes.object,
	zonesConfiguration: PropTypes.object,
	onActiveDivisionChange: PropTypes.func,
};

export default ControlPanel;
